var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.$router.options.routes),function(route,i){return [(route.meta && !route.meta.hidden)?_c('v-btn',{key:i,class:{ 'ml-2': (i > 0) },attrs:{"large":"","text":"","to":route,"active-class":"secondary--text"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(route.meta.icon))]),_vm._v(_vm._s(route.meta.title)+" ")],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }